import React, { useState, useEffect } from 'react';
import * as Utils from '../../common/utils';
import * as REQUEST from "../../common/request";
import './index.less';

const PageModel = props => {
    const [expandedSections, setExpandedSections] = useState({});

    const [url1510, setUrl1510] = useState('');
    const [url7, setUrl7] = useState('');
    const [url17, setUrl17] = useState('');
    const [list, setList] = useState([]);


    const toggleSection = (id) => {
        console.log(expandedSections);
        setExpandedSections(prev => ({
            ...prev,
            [id]: !prev[id], // 切换当前 id 的展开状态
        }));
    };
    const get1510 = async () => {
        const result = await REQUEST.get({
            url: '/zhujiajiao/v2/file/get',
            data: { id: 2 }
        });
        if (!result) return;
        setUrl1510(result.data.link);
    };
    const get17 = async () => {
        const result = await REQUEST.get({
            url: '/zhujiajiao/v2/file/get',
            data: { id: 3 }
        });
        if (!result) return;
        setUrl17(result.data.link);
    };
    const get7 = async () => {
        const result = await REQUEST.get({
            url: '/zhujiajiao/v2/file/get',
            data: { id: 7 }
        });
        if (!result) return;
        setUrl7(result.data.link);
    };
    const getList = async () => {
        const originalData = await REQUEST.get({
            url: '/zhujiajiao/v2/trans/list',
        });
        if (!originalData) return;

        // 按type分类
        const groupedByType = originalData.data.reduce((acc, item) => {
            const type = item.type;
            if (!acc[type]) {
                acc[type] = [];
            }
            acc[type].push(item);
            return acc;
        }, {});

        // 转换为数组形式（如果需要）
        const result = Object.keys(groupedByType).map(type => ({
            type: parseInt(type),
            name: { 1: '机场线路', 2: '自驾线路', 3: '公交线路' }[type],
            icon: groupedByType[type][0].icon,
            items: groupedByType[type]
        }));
        setList(result);
    };
    useEffect(() => {
        get1510();//获取1510公交线路图
        get17();//获取17公交线路图
        getList();//获取所有线路信息
        get7();
        Utils.setPageTitle('旅游交通');
        return () => false;
    }, [123]);

    return (
        <section className="h5tran-container" style={{ minHeight: window.innerHeight }}>
            {list.length > 0 && list.map((item, index) => {
                return (
                    <div className="airport-route-container" key={index}>
                        <div className='airport-route-container-title'>
                            <img src={'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/' + item.icon} alt="" ></img>
                            <div>{item.name}</div>
                        </div>
                        <div className="route-section-content">
                            {
                                item.items && item.items.length > 0 && item.items.map((item2, index2) => {
                                    return (
                                        <div className="sub-sections" key={index2}>
                                            <div className="sub-section">
                                                <div className="sub-header" onClick={() => toggleSection(item2.id)}>
                                                    <div className='sub-header-title'>{item2.name}</div>
                                                    <span className={`arrow ${expandedSections[`${item2.id}`] ? "expanded" : ""}`}>
                                                        ▼
                                                    </span>
                                                </div>
                                                {expandedSections[`${item2.id}`] && (
                                                    <div className="sub-details">
                                                        <p>{item2.content}</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                )
            })
            }
            <div className='h5tran-bottom0-img'>
                <img src={'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/' + url1510} alt="" />
            </div>
            <div className='h5tran-bottom0-img'>
                <img src={'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/' + url7} alt="" />
            </div>

            <div className='h5tran-bottom1-img'>
                <img src={'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/' + url17} alt="" />
            </div>
            <div className='h5tran-bottom-img'>
                <img src={require('./images/bottom.png')} alt="" />
            </div>
        </section>
    );
};

export default PageModel;
